import { render, staticRenderFns } from "./UserPasswordForget.vue?vue&type=template&id=f70d751e&"
import script from "./UserPasswordForget.vue?vue&type=script&lang=js&"
export * from "./UserPasswordForget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports